"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriberItem = exports.subscriberItemTestIds = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const silhouette_core_1 = require("@freighthub/silhouette-core");
const Actors_1 = require("../types/Actors");
const MemberItem_1 = require("./MemberItem");
exports.subscriberItemTestIds = {
    removeIcon: 'subscriber_remove',
    subscriberItem: 'subscriber-list_item',
};
const trackingIds = {
    removeSubscriber: 'subscription_popup-remove_subscriber',
};
const useStyles = (0, silhouette_core_1.makeStyles)(() => ({
    listItem: {
        paddingLeft: 0,
    },
    avatar: {
        width: 'auto',
    },
}));
const SubscriberItem = ({ actor, removeSubscriber, idType, isDisabled }) => {
    const classes = useStyles();
    const { id, name } = (0, Actors_1.generateActorInfo)(idType, actor);
    return ((0, jsx_runtime_1.jsxs)(silhouette_core_1.ListItem, { className: classes['listItem'], "data-testid": exports.subscriberItemTestIds.subscriberItem, children: [(0, jsx_runtime_1.jsx)(silhouette_core_1.ListItemAvatar, { children: (0, jsx_runtime_1.jsx)(MemberItem_1.MemberItem, { idType: idType, actor: actor, disabled: true, displayName: false, className: classes['avatar'] }) }), (0, jsx_runtime_1.jsx)(silhouette_core_1.ListItemText, { primary: name, secondary: actor.email }), (0, jsx_runtime_1.jsx)(silhouette_core_1.ListItemSecondaryAction, { children: !isDisabled && ((0, jsx_runtime_1.jsx)(silhouette_core_1.IconButton, { "data-tracking-id": `${idType}-${trackingIds.removeSubscriber}`, "data-testid": exports.subscriberItemTestIds.removeIcon, onClick: () => (removeSubscriber ? removeSubscriber(id, idType) : null), children: (0, jsx_runtime_1.jsx)(silhouette_core_1.CloseIcon, {}) })) })] }));
};
exports.SubscriberItem = SubscriberItem;
//# sourceMappingURL=SubscriberItem.js.map